// apps/mtd-itsa-web/src/components/application/error-fallback/error-fallback.tsx
import { Button } from "@/components/base/buttons/button";


type Props = {
    title?: string;
    error?: unknown;
    resetError?: () => void;
};


export default function ErrorFallback({ title = "Something went wrong", error }: Props) {
    const message =
        error instanceof Error ? error.message : "An unexpected error occurred.";


    return (
        <div className="min-h-dvh w-full bg-primary p-4 md:p-6 flex items-center justify-center">
            <div className="w-full max-w-md rounded-2xl border border-secondary bg-primary p-6 shadow-xl">
                <h1 className="text-lg font-semibold text-primary">{title}</h1>
                <p className="mt-2 text-sm text-tertiary">
                    Please try again or contact support.
                </p>

                <div className="mt-4 rounded-lg border border-secondary bg-secondary30 p-3">
                    <p className="text-xs text-tertiary wrap-break-word">{message}</p>
                </div>

                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                    <Button
                        size="md"
                        color="primary"
                        className="w-full"
                        onClick={() => window.history.back()}
                    >
                        Go back
                    </Button>
                </div>

                <button
                    type="button"
                    className="mt-4 text-sm text-tertiary underline hover:text-primary"
                    onClick={() => window.location.reload()}
                >
                    Reload page
                </button>
            </div>
        </div>
    );
}
